import Error from 'next/error'

export default function () {
    return <Error statusCode="404" />
}
